// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Site
 */
export interface Site {
  /**
   *
   */
  id?: string;
  /**
   *
   */
  name: string;
  /**
   *
   */
  url: string;
}

/**
 * Check if a given object implements the Site interface.
 */
export function instanceOfSite(value: object): value is Site {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("url" in value) || value["url"] === undefined) return false;
  return true;
}

export function SiteFromJSON(json: any): Site {
  return SiteFromJSONTyped(json, false);
}

export function SiteFromJSONTyped(json: any, ignoreDiscriminator: boolean): Site {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    name: json["name"],
    url: json["url"],
  };
}

export function SiteToJSON(json: any): Site {
  return SiteToJSONTyped(json, false);
}

export function SiteToJSONTyped(value?: Site | null, ignoreDiscriminator: boolean = false): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    name: value["name"],
    url: value["url"],
  };
}
